export default "__VITE_PUBLIC_ASSET__5e67a0a7__"